




import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BadgeIcon from "@mui/icons-material/Badge";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupsIcon from "@mui/icons-material/Groups";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import axios from "axios";
import ApiCallService from "../../Service/ApiCallService";
import Spinner from "../../components/common/Spinner";

const DastakChapterViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [chapter, setChapter] = useState(null);
  const [members, setMembers] = useState([]);

 useEffect(() => {
  const loadData = async () => {
    await fetchChapter();
    await fetchMembers();
  };

  loadData();
}, [id]);

  const fetchChapter = async () => {
    try {
      setLoading(true);
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/getChapterById/${id}`
      );
      setChapter(res?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMembers = async () => {


    try {
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/membersByChapter/${id}`
      );
      setMembers(res.data || []);
    } catch (err) {
      console.error(err);
    }


  };




  if (loading ) {
    return (
      <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Skeleton variant="rounded" width={96} height={38} />
            <Box sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="35%" height={34} />
              <Skeleton variant="text" width="22%" height={22} />
            </Box>
            <CircularProgress size={28} />
          </Stack>

          <Grid container spacing={2.5}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item}>
                <Skeleton variant="rounded" height={120} sx={{ borderRadius: 3 }} />
              </Grid>
            ))}
            <Grid item xs={12} md={7}>
              <Skeleton variant="rounded" height={260} sx={{ borderRadius: 3 }} />
            </Grid>
            <Grid item xs={12} md={5}>
              <Skeleton variant="rounded" height={260} sx={{ borderRadius: 3 }} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }




  const loc = chapter?.location || {};

  const getStatusColor = (status) => {
    const value = `${status || ""}`.toLowerCase();
    if (value.includes("active") || value.includes("approved")) return "success";
    if (value.includes("pending") || value.includes("progress")) return "warning";
    if (value.includes("inactive") || value.includes("reject") || value.includes("closed")) return "error";
    return "primary";
  };



  const locationItems = [
    { label: "State", value: loc.state?.stateName || "-", icon: <MapIcon fontSize="small" /> },
    { label: "Region", value: loc.region?.regionName || "-", icon: <LocationOnIcon fontSize="small" /> },
    { label: "District", value: loc.district?.districtName || "-", icon: <LocationOnIcon fontSize="small" /> },
    { label: "Taluka", value: loc.taluka?.talukaName || "-", icon: <LocationOnIcon fontSize="small" /> },
    { label: "Village", value: loc.village?.villageName || "-", icon: <LocationOnIcon fontSize="small" /> },
  ];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f6f8fb", py: { xs: 2, md: 4 } }}>
      <Container maxWidth="xl">
        <Spinner loading={loading}/>

        {/* <Paper
          elevation={0}
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            mb: 3,
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 2,
            background: "linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              >
                Back
              </Button>

              <Box>
                <Typography variant="h4" sx={{ fontWeight: 700, color: "text.primary" }}>
                  Chapter Details
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Sadhu Sadhvi Dastak chapter profile and member overview
                </Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Chip
                icon={<TaskAltIcon />}
                label={chapter?.chapterStatus || " "}
                color={getStatusColor(chapter?.chapterStatus)}
                sx={{ fontWeight: 700, borderRadius: 2 }}
              />
              <Chip
                icon={<GroupsIcon />}
                label={`${members.length} Members`}
                variant="outlined"
                sx={{ fontWeight: 700, borderRadius: 2, bgcolor: "background.paper" }}
              />
            </Stack>
          </Stack>
        </Paper> */}

        <Grid container spacing={2.5}>
       

          <Grid item xs={12} lg={7}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                boxShadow: 3,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                  <Avatar sx={{ bgcolor: "primary.main" }}>
                    <BadgeIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      Chapter Information
                    </Typography>
                    {/* <Typography variant="body2" color="text.secondary">
                      Core chapter identity and operational status
                    </Typography> */}
                  </Box>
                </Stack>

                <Divider sx={{ mb: 2.5 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc", border: "1px solid", borderColor: "divider" }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Name
                      </Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {chapter?.chapterName || " "}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc", border: "1px solid", borderColor: "divider" }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Code
                      </Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {chapter?.chapterUniqueCode || " "}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc", border: "1px solid", borderColor: "divider" }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        Status
                      </Typography>
                      <Chip label={chapter?.chapterStatus || " "} color={getStatusColor(chapter?.chapterStatus)} sx={{ fontWeight: 700 }} />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#f8fafc", border: "1px solid", borderColor: "divider" }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Lifecycle
                      </Typography>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {chapter?.chapterLifecycleStatus || " "}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} lg={5}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                boxShadow: 3,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                  <Avatar sx={{ bgcolor: "success.main" }}>
                    <LocationOnIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      Location Details
                    </Typography>
                
                  </Box>
                </Stack>

                <Divider sx={{ mb: 2.5 }} />

                <Grid container spacing={1.5}>
                  {locationItems.map((item) => (
                    <Grid item xs={12} sm={6} key={item.label}>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="center"
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                          border: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Avatar sx={{ width: 32, height: 32, bgcolor: "background.paper", color: "success.main" }}>
                          {item.icon}
                        </Avatar>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="body2" color="text.secondary">
                            {item.label}
                          </Typography>
                          <Typography variant="subtitle1" sx={{ fontWeight: 700, wordBreak: "break-word" }}>
                            {item.value}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 3,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", sm: "center" }}
                  spacing={1.5}
                  sx={{ mb: 2 }}
                >
                  <Stack direction="row" alignItems="center" spacing={1.5}>
                    <Avatar sx={{ bgcolor: "secondary.main" }}>
                      <Diversity3Icon />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        Chapter Members
                      </Typography>
                  
                    </Box>
                  </Stack>

              
                </Stack>

                <Divider sx={{ mb: 2.5 }} />

                {members.length === 0 ? (
                  <Box
                    sx={{
                      py: 6,
                      px: 2,
                      textAlign: "center",
                      borderRadius: 3,
                      bgcolor: "#f8fafc",
                      border: "1px dashed",
                      borderColor: "divider",
                    }}
                  >
                    <Avatar sx={{ mx: "auto", mb: 1.5, bgcolor: "background.paper", color: "text.secondary" }}>
                      <GroupsIcon />
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      No members found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Members will appear here once they are assigned to this chapter.
                    </Typography>
                  </Box>
                ) : (
                  <Grid container spacing={2}>
                    {members.map((m) => (
                      <Grid item xs={12} sm={6} lg={4} key={m._id}>
                        <Card
                          variant="outlined"
                          sx={{
                            height: "100%",
                            borderRadius: 3,
                            bgcolor: "#ffffff",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
                            "&:hover": {
                              transform: "translateY(-3px)",
                              boxShadow: 4,
                              borderColor: "primary.light",
                            },
                          }}
                        >
                          <CardContent>
                            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                              <Avatar
                                sx={{
                                  width: 48,
                                  height: 48,
                                  bgcolor: "primary.main",
                                  fontWeight: 700,
                                }}
                              >
                                {`${m.user?.userFirstName || " "}`.trim().charAt(0) || "M"}
                              </Avatar>

                              <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, wordBreak: "break-word" }}>
                                  {m.user?.userFirstName || " " } {m.user?.userLastName || " "}
                                </Typography>

                              

                                <Chip
                                  label={m.role?.name || " "}
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  sx={{ mt: 1.5, fontWeight: 700, borderRadius: 2 }}
                                />
                              </Box>
                            </Stack>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DastakChapterViewPage;
